module.exports = __webpack_public_path__ + "img/brand--oslo.f5cfa1fd.png";